import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import InputComponent from '../../components/InputComponent';
import { useAuth } from '../../contexts/AuthContext';
import { buildApiUrl } from '../../utils/apiUrl';

const ClientInfo = () => {
	const { register, setValue, watch, getValues } = useFormContext();
	const { user } = useAuth();
	const [suggestions, setSuggestions] = useState([]);
	const companyName = watch('companyName') || '';

	// Auto-fill orderer fields from the logged-in user (via AuthContext)
	useEffect(() => {
		if (user) {
			const name = user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim();
			setValue('ordererName', name);
			setValue('ordererEmail', user.email || '');
			if (!String(getValues('ordererPhone') || '').trim()) {
				setValue('ordererPhone', user.telephone || '');
			}
		}
	}, [user, setValue, getValues]);

	const handleQueryChange = async (e) => {
		const value = e.target.value;
		setValue('companyName', value, { shouldValidate: true });

		if (value.length > 0) {
			try {
				const response = await axios.get(
					`${buildApiUrl('clients/search')}?q=${encodeURIComponent(value)}`
				);
				setSuggestions(response.data);
			} catch (error) {
				console.error('Error fetching client suggestions:', error);
			}
		} else {
			setSuggestions([]);
		}
	};

	const handleSuggestionClick = (suggestion) => {
		setValue('companyName', suggestion.name, { shouldValidate: true });
		setSuggestions([]);
	};

	return (
		<div className='clientInfo flex flex-row'>
			<div>
				<div className='autocomplete'>
					<InputComponent
						label='Firmanavn kunde'
						type='text'
						name='companyName'
						value={companyName}
						required
						register={register}
						onChange={handleQueryChange}
						autoComplete='off'
					/>
					{suggestions.length > 0 && (
						<ul className='suggestions'>
							{suggestions.map((suggestion, index) => (
								<li
									key={index}
									onClick={() =>
										handleSuggestionClick(suggestion)
									}
								>
									{suggestion.name}
								</li>
							))}
						</ul>
					)}
				</div>
			</div>
			<div>
				<InputComponent
					label='Navn på bestiller AC'
					type='text'
					name='ordererName'
					required
					register={register}
					readOnly
				/>
			</div>
			<div>
				<InputComponent
					label='Epost til bestiller AC'
					type='email'
					name='ordererEmail'
					required
					register={register}
					readOnly
				/>
			</div>
			<div>
				<InputComponent
					label='Telefon'
					type='tel'
					name='ordererPhone'
					required
					register={register}
				/>
			</div>
		</div>
	);
};

export default ClientInfo;
